import {FC, useEffect} from "react";
import { TextField, Tooltip } from "@material-ui/core";
import * as React from "react";
import { HashTokenData } from "./types/hashTokenData";

interface Props {
    hash_token: HashTokenData;
    init_value: "";
}

const HashToken: FC<Props> = ({ hash_token, init_value }) => {

    const [key, setKey] = React.useState<any>('');

    useEffect(() => {
        if (init_value!=""){
            setKey(init_value)
        }

    }, [init_value])
    return (
        <Tooltip title="The key needed to generate the internal hash token for stream protection" placement='top-end' aria-multiline>
            <TextField
                label="Hash Token Key"
                placeholder="Hash Token Key"
                value={key}
                defaultValue={typeof init_value !='undefined' ? init_value : key}
                variant="outlined"
                fullWidth
                onChange={e => {
                    setKey(e.target.value)
                    hash_token(e.target.value)
                }}
            />
        </Tooltip>
    )
}

export default HashToken;
